import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const FooterContainer = styled.footer`
  background-color: #101522;
  margin-top: 2rem;
`;

export const FooterWrap = styled.div`
  padding: 48px 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 1400px;
  margin: 0 auto;
  /* border: 2px solid blue; */
`;

export const FooterInfoContainer = styled.div`
  max-width: 1000px;
  width: 100%;
  display: flex;
  justify-content: space-between;

  @media screen and (max-width: 820px) {
    /* padding-top: 32px; */
    flex-direction: column;
  }
  /* border: 2px solid blue; */
`;

export const SocialLogo = styled(Link)`
  color: #fff;
  justify-self: start;
  cursor: pointer;
  text-decoration: none;
  font-size: 1.5rem;
  display: flex;
  /* align-items: center; */
  margin-bottom: 2rem;
  letter-spacing: 2px;
  font-weight: 500;
`;

export const SocialIcons = styled.div`
  display: flex;
  justify-content: space-between;
  /* align-items: center; */
  width: 75px;
  /* border: 2px solid blue; */
`;

export const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  color: #fff;

  /* justify-content: space-between; */
  /* align-items: center; */
  /* width: 125px; */
  /* border: 2px solid red; */
`;

export const FooterSectionTitle = styled.h1`
  font-size: 16px;
  /* font-size: 1.25rem; */
  margin: 0 0 16px 0;
  /* border-bottom: 1px solid #f8971d; */
`;

export const FooterSectionItems = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 10px;
  /* border: 2px solid red; */

  /* 
  @media screen and (max-width: 820px) {
    padding-top: 32px;
  } */
`;

export const SectionItem = styled.div`
  display: flex;
  width: 250px;
  font-size: 14px;
  margin: 10px 0;
  /* padding: 0 1rem; */
  justify-content: space-between;
  /* flex-direction: column; */
  /* border: 2px solid red; */

  /* 
  @media screen and (max-width: 820px) {
    padding-top: 32px;
  } */
`;

export const IconContainer = styled.div`
  font-size: 25px;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  /* color: grey; */
  /* font-weight: 300; */
  /* opacity: 0.5; */
`;

export const ItemTitle = styled.div`
  width: 220px;
  display: flex;
  padding: 0 1rem;
  letter-spacing: 1.5px;
  /* color: #fff; */
  margin-bottom: 0.5rem;
  font-size: 14px;
`;

export const FooterLink = styled(Link)`
  color: #fff;
  text-decoration: none;
  margin-bottom: 0.5rem;
  font-size: 14px;

  &:hover {
    color: #f8971d;
    transition: 0.3s ease-out;
  }
`;

export const SocialMedia = styled.section`
  max-width: 1000px;
  width: 100%;
  /* border: 2px solid blue; */
`;

export const SocialMediaWrap = styled.div`
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
  border-top: 1px solid grey;
  padding-top: 1rem;
  /* align-items: center; */
  max-width: 1100px;
  margin: 40px auto 0 auto;

  @media screen and (max-width: 820px) {
    flex-direction: column;
  }
`;

export const WebsiteRights = styled.div`
  display: flex;
  color: #fff;
  margin-bottom: 16px;
  /* border: 1px solid blue; */
  font-size: 14px;
  /* font-weight: 500; */
`;

export const SocialIconLink = styled.a`
  color: #fff;
  font-size: 30px;
`;
